import { Button } from '@sainsburys-tech/luna-button'
import { Modal, GridItem } from '@sainsburys-tech/luna-react'
import { Body1, Display3 } from '@sainsburys-tech/luna-typography'
import { IPrompt } from '../../../../../types/ComponentTypes/Components'
import IconComponent from '../IconComponent'
import parse from 'html-react-parser'

function PromptComponent({ title, body, text, icon, handleResult }: IPrompt) {

  return (
    <Modal small alert hideCloseButton open={true} headingId="dialog-modal">
      <GridItem className="ln-u-hard">
        {icon ? (
          <IconComponent {...icon}/>
        ) : null}
      </GridItem>
      <GridItem className="ln-u-text-align-center s-padding-bottom-10">
        <Display3>{title}</Display3>
      </GridItem>
      <GridItem className="ln-u-hard ln-u-text-align-left">
        <Body1 >
          {parse(body || '')}
        </Body1>
      </GridItem>
      <Button
        circle={false}
        disabled={false}
        hard={false}
        element="button"
        variant="filled"
        fullWidth
        className="s-continue-button ln-u-margin-ends*2"
        onClick={() => handleResult(true)}
      >
        {text}
      </Button>
      <Button
        circle={false}
        disabled={false}
        hard={false}
        element="button"
        variant="outlined"
        fullWidth
        className="s-reset-button"
        onClick={() => handleResult(false)}
      >
        Cancel
      </Button>
    </Modal>
  )
}

export default PromptComponent